// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OXmE","top":"styles_top__2SH0R","left":"styles_left__28Rn4","description":"styles_description__3ZXjY"};